import React from 'react';
import { QuoteBlockStyles as S } from './QuoteBlock.styles';
const QuoteBlock = (props) => {
    return (React.createElement(S.Container, { id: props.id, innerWidth: "narrow", flush: "top" },
        React.createElement(S.Blockquote, null,
            props.quote,
            React.createElement(S.Citation, null, props.citation))));
};
export default QuoteBlock;
